import { render, staticRenderFns } from "./BurgerBtn.vue?vue&type=template&id=393d3dbc"
import script from "./BurgerBtn.vue?vue&type=script&lang=ts"
export * from "./BurgerBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports